import { useTranslation } from 'react-i18next';

import { notify } from 'libs/common';
import { Content } from './to-clip.styled';

async function copyToClipboard(textToCopy) {
  if (navigator.clipboard) {
    await navigator.clipboard.writeText(textToCopy);
  } else {
    const textarea = document.createElement('textarea');
    textarea.value = textToCopy;
    textarea.style.position = 'absolute';
    textarea.style.left = '-99999999px';
    document.body.prepend(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
    } catch (err) {
      console.log(err);
    } finally {
      textarea.remove();
    }
  }
}

export const ToClip = (props) => {
  const { value, title } = props;
  const { t } = useTranslation();

  const copy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await copyToClipboard(value);
      console.log(value);
    } catch (err) {
      console.log(err);
      notify(t('windows.Внимание'), t('errors.Нет доступа к буферу обмена'));
    }
  };

  return <Content title={title} onClick={copy} type="button"></Content>;
};
